import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';

export async function createSampleAssessmentGroup(examTaskGroupId: string): Promise<AxiosResponse<{ id: string }>> {
  return await axios.post(`${EnvWindow.REACT_APP_EXAMS_API_URL}/SampleAssessmentGroup`, {
    examTaskGroupId: examTaskGroupId,
  });
}

export async function deleteAssessmentTeamMember(sampleAssessmentGroupMemberId: string) {
  return await axios.delete(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/SampleAssessmentGroupMember/${sampleAssessmentGroupMemberId}`,
  );
}

export async function unassignSampleGroupAssesmentChairman(
  sampleAssessmentGroupChairmanId: string,
): Promise<AxiosResponse<boolean>> {
  return await axios.patch(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/SampleAssessmentGroupChairman/${sampleAssessmentGroupChairmanId}`,
  );
}
